const RES_LIST = {
  values: [0, 1, 2, 3, 4, 5, 6, 7],
  labels: ['[ Custom ]', 'HD 720', 'HD 1080', '640x480', 'Full 1024', '1k Square', '2k Square', 'Retina'],
};

const GeneralRenderer = {

  schema: {
    // general settings
    res: { label: 'Resolution', type: 'Options', defaultValue: '1', values: RES_LIST.values, labels: RES_LIST.labels },
    res_w: { label: 'Custom Width', type: 'Number', defaultValue: 1280, minValue: 100, isInteger: true },
    res_h: { label: 'Custom Height', type: 'Number', defaultValue: 720, minValue: 100, isInteger: true },
    output_dir: { label: 'Output directory', type: 'Text' },

    // current pass
    curPass: { label: 'Current Pass', type: 'Node' },

    // batch rendering
    frm_start: { label: 'Start Frame', type: 'Number', defaultValue: 1 },
    frm_last: { label: 'Last Frame', type: 'Number', defaultValue: 24 },
    frm_by: { label: 'By Frame', type: 'Number', defaultValue: 1 },

    ren_start: { label: 'Start number', type: 'Number', defaultValue: 1, isInteger: true },
    ren_by: { label: 'By Frame', type: 'Number', defaultValue: 1, isInteger: true },
    frm_pad: { label: 'Frame padding', type: 'Number', defaultValue: 1, minValue: 0, maxValue: 10, isInteger: true },
  },

};

export default { GeneralRenderer };



// WEBPACK FOOTER //
// ./src/operators/GeneralRenderer.js